"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destinationMapper = destinationMapper;
exports.legToDepartureMapper = legToDepartureMapper;

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getNoticesFromLeg(leg) {
  var _leg$serviceJourney, _leg$serviceJourney2, _leg$serviceJourney2$, _leg$serviceJourney3, _leg$serviceJourney3$, _leg$serviceJourney3$2, _leg$fromEstimatedCal;

  var notices = [].concat(_toConsumableArray(((_leg$serviceJourney = leg.serviceJourney) === null || _leg$serviceJourney === void 0 ? void 0 : _leg$serviceJourney.notices) || []), _toConsumableArray(((_leg$serviceJourney2 = leg.serviceJourney) === null || _leg$serviceJourney2 === void 0 ? void 0 : (_leg$serviceJourney2$ = _leg$serviceJourney2.journeyPattern) === null || _leg$serviceJourney2$ === void 0 ? void 0 : _leg$serviceJourney2$.notices) || []), _toConsumableArray(((_leg$serviceJourney3 = leg.serviceJourney) === null || _leg$serviceJourney3 === void 0 ? void 0 : (_leg$serviceJourney3$ = _leg$serviceJourney3.journeyPattern) === null || _leg$serviceJourney3$ === void 0 ? void 0 : (_leg$serviceJourney3$2 = _leg$serviceJourney3$.line) === null || _leg$serviceJourney3$2 === void 0 ? void 0 : _leg$serviceJourney3$2.notices) || []), _toConsumableArray(((_leg$fromEstimatedCal = leg.fromEstimatedCall) === null || _leg$fromEstimatedCal === void 0 ? void 0 : _leg$fromEstimatedCal.notices) || []));
  return (0, _utils.uniqBy)(notices, function (notice) {
    return notice.text;
  });
}

function getNotices(departure) {
  var _departure$serviceJou, _departure$serviceJou2, _departure$serviceJou3, _departure$serviceJou4, _departure$serviceJou5, _departure$serviceJou6;

  var notices = [].concat(_toConsumableArray(departure.notices || []), _toConsumableArray(((_departure$serviceJou = departure.serviceJourney) === null || _departure$serviceJou === void 0 ? void 0 : _departure$serviceJou.notices) || []), _toConsumableArray(((_departure$serviceJou2 = departure.serviceJourney) === null || _departure$serviceJou2 === void 0 ? void 0 : (_departure$serviceJou3 = _departure$serviceJou2.journeyPattern) === null || _departure$serviceJou3 === void 0 ? void 0 : _departure$serviceJou3.notices) || []), _toConsumableArray(((_departure$serviceJou4 = departure.serviceJourney) === null || _departure$serviceJou4 === void 0 ? void 0 : (_departure$serviceJou5 = _departure$serviceJou4.journeyPattern) === null || _departure$serviceJou5 === void 0 ? void 0 : (_departure$serviceJou6 = _departure$serviceJou5.line) === null || _departure$serviceJou6 === void 0 ? void 0 : _departure$serviceJou6.notices) || []));
  return (0, _utils.uniqBy)(notices, function (notice) {
    return notice.text;
  });
}

function destinationMapper(departure) {
  return _objectSpread(_objectSpread({}, departure), {}, {
    notices: getNotices(departure)
  });
}

function legToDepartureMapper(leg) {
  var fromEstimatedCall = leg.fromEstimatedCall;
  if (!fromEstimatedCall) return undefined;
  return {
    actualArrivalTime: fromEstimatedCall.actualArrivalTime,
    actualDepartureTime: fromEstimatedCall.actualDepartureTime,
    aimedArrivalTime: fromEstimatedCall.aimedArrivalTime,
    aimedDepartureTime: leg.aimedStartTime,
    cancellation: fromEstimatedCall.cancellation,
    date: fromEstimatedCall.date,
    destinationDisplay: fromEstimatedCall.destinationDisplay,
    expectedArrivalTime: fromEstimatedCall.expectedArrivalTime,
    expectedDepartureTime: leg.expectedStartTime,
    forAlighting: fromEstimatedCall.forAlighting,
    forBoarding: fromEstimatedCall.forBoarding,
    notices: getNoticesFromLeg(leg),
    predictionInaccurate: fromEstimatedCall.predictionInaccurate,
    quay: leg.fromPlace.quay,
    realtime: leg.realtime,
    requestStop: fromEstimatedCall.requestStop,
    serviceJourney: leg.serviceJourney,
    situations: leg.situations || []
  };
}